import filter from '../../../filters/filter';

const accommodationFilter = (filters) => ({
  ...filter(filters),

  options: ['category', 'classification', 'facility'],

  afterInit() {},

  async resetFilterClick(filter) {
    this.resetFilters(filter);
    await this.$nextTick();
    this.commit();
  },

  get isFiltered() {
    return this.options.some((item) => this.isFilteredBy(item));
  },

  get sortedFilters() {
    return this.getSortedFilters();
  },
});

export default accommodationFilter;
